import React from 'react';
import OwlCarousel from 'react-owl-carousel';  
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
export default function HomePortfolio(){
    return(
        <section id="projects" className="portfolio-area portfolio-bg nav-style-1 pt-120 pb-120 pt-xs-60 pt-xs-60">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8">
                        <div className="portfolio-section-title">
                            <h2 className="style-text">Portfolio</h2>
                            <h6 className="semi-title title-line">Portfolio</h6>
                            <h2 className="sect-title">Introduce Our Projects</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="custom-container-1">
                <div className="portfolio-slide">
                    <OwlCarousel items={3}  
                        className="owl-theme"  
                        loop 
                        dots={false}			  
                        margin={30} >
                        <div className="item">
                            <div className="portfolio-wrapper">
                                <img className="img-fluid" src="assets/img/portfolio/pr-1.jpg" alt="Portfolio Img" />
                                <span className="brand-logo"><img src="assets/img/portfolio/brand-logo-1.png" alt="Brand Logo" /></span>
                                <div className="single-portfolio">
                                    <span>UI & UX, IT Solution</span>
                                    <h4 className="portfolio-title text-white">Smartrics Web Solution</h4>
                                </div>
                                <Link className="pf-btn" to="case-details"><i className="fal fa-long-arrow-right"></i></Link>
                            </div>
                        </div>
                        <div className="item">
                            <div className="portfolio-wrapper">
                                <img className="img-fluid" src="assets/img/portfolio/pr-3.jpg" alt="Portfolio Img" />
                                <span className="brand-logo"><img src="assets/img/portfolio/brand-logo-1.png" alt="Brand Logo" /></span>
                                <div className="single-portfolio">
                                    <span>UI & UX, IT Solution</span>
                                    <h4 className="portfolio-title text-white">Smartrics Web Solution</h4>
                                </div>
                                <Link className="pf-btn" to="case-details"><i className="fal fa-long-arrow-right"></i></Link>
                            </div>
                        </div>
                        <div className="item">
                            <div className="portfolio-wrapper">
                                <img className="img-fluid" src="assets/img/portfolio/pr-1.jpg" alt="Portfolio Img" />
                                <span className="brand-logo"><img src="assets/img/portfolio/brand-logo-1.png" alt="Brand Logo" /></span>
                                <div className="single-portfolio">
                                    <span>UI & UX, IT Solution</span>
                                    <h4 className="portfolio-title text-white">Smartrics Web Solution</h4>
                                </div>
                                <Link className="pf-btn" to="case-details"><i className="fal fa-long-arrow-right"></i></Link>
                            </div>
                        </div>
                        <div className="item">
                            <div className="portfolio-wrapper">
                                <img className="img-fluid" src="assets/img/portfolio/pr-3.jpg" alt="Portfolio Img" />
                                <span className="brand-logo"><img src="assets/img/portfolio/brand-logo-1.png" alt="Brand Logo" /></span>
                                <div className="single-portfolio">
                                    <span>UI & UX, IT Solution</span>
                                    <h4 className="portfolio-title text-white">Smartrics Web Solution</h4>
                                </div>
                                <Link className="pf-btn" to="case-details"><i className="fal fa-long-arrow-right"></i></Link>
                            </div>
                        </div>
                        <div className="item">
                            <div className="portfolio-wrapper">
                                <img className="img-fluid" src="assets/img/portfolio/pr-1.jpg" alt="Portfolio Img" />
                                <span className="brand-logo"><img src="assets/img/portfolio/brand-logo-1.png" alt="Brand Logo" /></span>
                                <div className="single-portfolio">
                                    <span>UI & UX, IT Solution</span>
                                    <h4 className="portfolio-title text-white">Smartrics Web Solution</h4>
                                </div>
                                <Link className="pf-btn" to="case-details"><i className="fal fa-long-arrow-right"></i></Link>
                            </div>
                        </div>
                    </OwlCarousel>
                </div> 
            </div>
            
	    </section>
    )
}